import { render } from "./advisorProductAdviceContent.vue?vue&type=template&id=5ea7650c&scoped=true&ts=true"
import script from "./advisorProductAdviceContent.vue?vue&type=script&lang=ts"
export * from "./advisorProductAdviceContent.vue?vue&type=script&lang=ts"

import "./advisorProductAdviceContent.vue?vue&type=style&index=0&id=5ea7650c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea7650c"]])

export default __exports__